export const SDK_VERSION = '7.87.0';
